import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopHeader from './TopHeader';
import { BreadcrumbProvider } from './BreadcrumbContext';
import AccountPausedBanner from '../ui/AccountPausedBanner';
import TourController from '../../tours/TourController';
import IdleTimeout from '../IdleTimeout';
import { useAuth } from '../../context/AuthContext';

export default function DashboardLayout() {
  // Mobile drawer state. The Sidebar is the ONE nav renderer (desktop rail +
  // mobile drawer), so every role's menu stays a single source of truth
  // (getNavSectionsByRole) — there is no separate mobile list to go stale.
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const { user, refreshUser } = useAuth();

  // The stored user is a login-time snapshot; re-read /accounts/me/ once per
  // shell mount so a tenant whose landlord's organisation was suspended
  // (S1f: account_suspended) sees the "Payments paused" banner without
  // logging out and in.
  useEffect(() => { refreshUser(); }, [refreshUser]);

  // v1.4 B1 (W-1 on the web): a tenant's browser tab names their landlord,
  // never the platform (public/index.html's default title says LPMS).
  const brandName = user?.role === 'tenant' ? (user?.brand?.name || 'My Home') : null;
  useEffect(() => {
    if (!brandName) return undefined;
    const before = document.title;
    document.title = brandName;
    return () => { document.title = before; };   // sign-out / another role: the default title again
  }, [brandName]);

  return (
    <BreadcrumbProvider>
      <div className="flex min-h-screen bg-gray-50">
        <Sidebar open={mobileNavOpen} onClose={() => setMobileNavOpen(false)} />
        <div className="flex-1 min-w-0 ml-0 lg:ml-64">
          <TopHeader onMenuClick={() => setMobileNavOpen(true)} />
          <main className="p-6 lg:p-8">
            {user?.role === 'tenant' && user?.account_suspended && <AccountPausedBanner />}
            <Outlet />
            <TourController />
          </main>
          {/* v1.4.1 C7: the idle session timeout (signed-in shell only). */}
          <IdleTimeout />
        </div>
      </div>
    </BreadcrumbProvider>
  );
}